import { blogService } from '../services/blog.service';

export default function Blog() {
  return (
    <>
    aasdf
    </>
  );
}
